import countryCodes from '../../public/static/country.codes.json';

const getParsedPhone = completedPhone => {
  let countryCode = 'gb',
    countryDialCode = '+44',
    mobileNumber = '';
  countryCodes.forEach(country => {
    if (completedPhone.startsWith(country.dial_code)) {
      mobileNumber = completedPhone.replace(country.dial_code, '');
      countryDialCode = country.dial_code;
      countryCode = country.code.toLowerCase();
      return;
    }
  });
  return {
    countryCode,
    countryDialCode,
    mobileNumber,
  };
};

export default getParsedPhone;
